import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpenText } from "lucide-react";
import { Nav, Footer } from "./Nav";
import { MAAT_LAWS, GEOMETRY, CATEGORY_META } from "../data/mock";
import { Seo } from "./Seo";

export function Wusabat() {
  const [open, setOpen] = useState(null);
  return (
    <>
      <Seo title="The Wu'sabat Path" description="Discover the Wu'sabat path — the ancient roots behind Ely Wellbeing's modern practice, including the Maat laws and sacred geometry." />
      <Nav />
      <section className="hero" style={{ padding: "8rem 0 2.5rem" }}>
        <div className="wrap hero-inner">
          <span className="eyebrow">THE WU'SABAT PATH</span>
          <h1>Know Thyself,<br />Heal Thyself.</h1>
          <p className="lead">The philosophical heart of ElyWellbeing — where ancient Egyptian wisdom becomes a practical path for modern healing.</p>
          <div className="as-above">“As above, so below.”</div>
        </div>
      </section>

      <section className="sec">
        <div className="wrap">
          <div className="philosophy">
            <span className="eyebrow">GUIDING PHILOSOPHY</span>
            <h2>As Above, So Below</h2>
            <p className="muted" style={{ maxWidth: 720, margin: ".6rem auto 0" }}>
              To “Know Thyself” is the foundation of all healing. The Wu'sabat path teaches that our inner world and outer world reflect one another — when we bring the mind, body and spirit into harmony, our lives come into balance. These principles are not a rulebook, but a living framework woven through every course, therapy and practice here.
            </p>
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="wrap">
          <div className="sec-head"><span className="eyebrow">THE FRAMEWORK</span><h2>The 11 Laws of Maat</h2><p className="muted">Tap a law to see its wellness connection and related practices.</p></div>
          <div className="laws-grid">
            {MAAT_LAWS.map((l, i) => (
              <div key={l.n} className="law" onClick={() => setOpen(open === i ? null : i)}>
                <div className="ln">LAW {l.n}</div>
                <h3>{l.name}</h3>
                <div className="theme">{l.theme}</div>
                {open === i && (
                  <div className="expand">
                    <p className="muted">{l.connection}</p>
                    <div className="rel">
                      {l.related.map((r) => <Link key={r} to="/courses" onClick={(e) => e.stopPropagation()}>Related →</Link>)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--sand)" }}>
        <div className="wrap">
          <div className="sec-head"><span className="eyebrow">ORDER & BALANCE</span><h2>Sacred Geometry & Mathematics</h2></div>
          <div className="geo-grid">
            {GEOMETRY.map((g) => (
              <div className="geo" key={g.title}>
                <div className="sym">{g.symbol}</div>
                <h3>{g.title}</h3>
                <p className="muted">{g.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="wrap">
          <div className="philosophy" style={{ background: "linear-gradient(135deg,#8B5A3C,#C9A96E)", color: "#fff", border: 0 }}>
            <BookOpenText size={30} style={{ opacity: .9 }} />
            <h2 style={{ color: "#fff" }}>The Weighing of the Will & Mind</h2>
            <p style={{ color: "#fff", opacity: .92, maxWidth: 560, margin: ".4rem auto 1.2rem" }}>Reflect daily on how you are living the 11 Laws. Your Maat journal lives in your Wellbeing Hub.</p>
            <Link className="btn btn-soft" to="/hub">Open my journal <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
